import { Row, Col, Space, Select } from 'antd';
import { ReactComponent as POI } from '../../assets/images/POI.svg';
import { ReactComponent as Phone } from '../../assets/images/phone.svg';
import { ReactComponent as Mail } from '../../assets/images/mail.svg';
import { Link } from 'react-router-dom';
import MapWrapper from '../../map/Index';
import { useEffect, useState } from 'react';
import { ContactResponse } from '../../modules/contact-us/types';
import { Feature } from 'ol';
import { Geometry, Point } from 'ol/geom';
import * as olProj from 'ol/proj';
import { useLazyGetLinkListQuery } from '../../redux/api/SystemApi';
import { useAppSelector } from '../../redux/Hooks';
import Logo from '../../assets/images/IconAmber.svg';
// import IconViettel from '../../assets/images/IconViettel.png';

const Footer = () => {
    const [headquarter, setHeadquarter] = useState<ContactResponse>();
    const [features, setFeatures] = useState<Feature<Geometry>[]>([]);
    const [linkTrigger, linkResponse] = useLazyGetLinkListQuery();

    const userState = useAppSelector(state => state.login);

    useEffect(() => {
        linkTrigger({});
    }, [linkTrigger])

    useEffect(() => {
        if (userState.contacts.content.length) {
            setHeadquarter(userState.contacts.content.find(item => item.type === 0))

            let iconFeatures: Feature<Geometry>[] = [];
            userState.contacts.content.forEach(item => {
                let newFeature = new Feature({
                    geometry: new Point([item.lon, item.lat]),
                    name: item.title,
                    address: item.address,
                    url: `https://www.google.com/maps/search/?api=1&query=${item.lat}%2C${item.lon}`,
                    location: [item.lon, item.lat],
                })

                newFeature.getGeometry()?.transform('EPSG:4326', 'EPSG:3857')
                iconFeatures.push(newFeature)
            })

            setFeatures(iconFeatures)
        }
    }, [userState.contacts.content])

    const onSelectChange = (value: number) => {
        if (value) {
            let linkItem = linkResponse.data?.find(item => item.id === value);
            if (linkItem) {
                window.open(linkItem.url, "_blank", "noopener,noreferrer")
            }
        }
    }

    return (
        <Row className='footer' justify='center'>
            <Col span={16} className="footer-info">
                {/* <img src={Logo} alt="logo" style={{ height: 85 }} /> */}
                <Space>
                    <div>
                        {/* <span style={{ color: "rgba(182, 124, 11, 1)", fontSize: 18 }}>Logo</span> */}
                        {/* <IconAmber /> */}
                        <img src={Logo} alt="logo" style={{ height: 85 }} />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div className="font-size-24"><span className="font-bold">ĐẤU GIÁ TRỰC TUYẾN</span></div>
                        <span style={{ color: '#322D1F' }}>TRUNG TÂM DỊCH VỤ ĐẤU GIÁ TÀI SẢN TP.HỒ CHÍ MINH</span>
                    </div>
                </Space>
                <Row>
                    <Col span={16}>
                        <div style={{ paddingRight: 10 }}>
                            <div className='text-overflow-custom-one-line' style={{ display: 'flex', alignItems: 'center' }}>
                                <POI style={{ height: 20 }} /><span style={{ paddingLeft: 20 }}>{headquarter?.address || "..."}</span>
                            </div>
                            <div className='text-overflow-custom-one-line' style={{ display: 'flex', alignItems: 'center' }}>
                                <Phone style={{ height: 20, color: 'black' }} /><span style={{ paddingLeft: 17 }}>
                                    {headquarter?.mobile ?
                                        <a href={`tel:${headquarter.mobile}`}>{headquarter.mobile}</a>
                                        : "..."
                                    }
                                </span>
                            </div>
                            <div className='text-overflow-custom-one-line' style={{ display: 'flex', alignItems: 'center' }}>
                                <Mail style={{ height: 20, color: 'black' }} /><span style={{ paddingLeft: 16 }}>
                                    {headquarter?.email ?
                                        <a href={`mailto:${headquarter.email}`}>{headquarter.email}</a>
                                        : "..."
                                    }
                                </span>
                            </div>
                        </div>
                    </Col>
                    <Col span={8}>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', flexDirection: 'column', height: '100%' }}>
                            <span className="font-size-18 font-bold">Thông tin chung</span>
                            <Row>
                                <Col span={14} className='text-overflow-custom-one-line'>
                                    <Link to="/intro" className="hover-link">
                                        Giới thiệu
                                    </Link>
                                </Col>
                                <Col span={10} className='text-overflow-custom-one-line'>
                                    <Link to="/procedure" className="hover-link">
                                        Hướng dẫn
                                    </Link>
                                </Col>
                                <Col span={14} className='text-overflow-custom-one-line'>
                                    <Link to="/auction-list/upcoming" className="hover-link">
                                        Thông tin đấu giá
                                    </Link>
                                </Col>
                                <Col span={10} className='text-overflow-custom-one-line'>
                                    <Link to="/event" className="hover-link">
                                        Tin tức
                                    </Link>
                                </Col>
                            </Row>
                        </div>
                        {/* <Select
                            allowClear
                            placeholder="Liên kết website"
                            style={{ marginTop: 30, width: '100%' }}
                            onChange={(value) => onSelectChange(value)}
                        >
                            {linkResponse.data?.map(item => (
                                <Select.Option key={item.id} value={item.id}>
                                    {item.title}
                                </Select.Option>
                            ))}
                        </Select> */}
                    </Col>
                </Row>
            </Col>
            <Col span={8}>
                {/* <iframe
                    title="map"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3724.0206432282453!2d105.78272290000001!3d21.03186!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3135ab4b50e26a67%3A0x6c815bc9efd9bd9e!2zMiBOZ8O1IDgyIFBo4buRIER1eSBUw6JuLCBE4buLY2ggVuG7jW5nIEjhuq11LCBD4bqndSBHaeG6pXksIEjDoCBO4buZaQ!5e0!3m2!1sen!2s!4v1649838630271!5m2!1sen!2s"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen={false}
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade">
                </iframe> */}
                {headquarter && headquarter.lat && headquarter.lon ?
                    <div style={{ paddingRight: 80 }}>
                        <MapWrapper features={features} center={olProj.transform([headquarter.lon, headquarter.lat], 'EPSG:4326', 'EPSG:3857')} zoom={15} />
                    </div>
                    : <></>}
            </Col>
        </Row>
    )
}

export default Footer;